import api from "./http";
import dataMappingService from "./dataMappingService";

const API_URL = `/api/tickets`;

function fromApiListResponse(data) {
  if (data && Array.isArray(data["hydra:member"])) {
    return data["hydra:member"];
  }
  if (data && Array.isArray(data["member"])) {
    return data["member"];
  }
  return Array.isArray(data) ? data : [];
}

function toApiPayload(data) {
  const payload = {
    titre: data.titre,
    description: data.description,
  };
  if (data.client) payload.clientId = `/api/clients/${data.client}`;
  if (data.contact) payload.contactId = `/api/contacts/${data.contact}`;
  if (data.collaborateur) payload.collaborateurId = `/api/collaborateurs/${data.collaborateur}`;
  if (data.statut) payload.statutId = `/api/statuts/${data.statut}`;
  if (data.tpsResolution !== "" && data.tpsResolution !== null && data.tpsResolution !== undefined) {
    const n = Number(data.tpsResolution);
    if (!Number.isNaN(n)) payload.tpsResolution = n;
  }
  if (data.note && data.note.trim()) {
    payload.note = data.note.trim();
  }
  return payload;
}

const ACCEPT_JSONLD = { headers: { Accept: "application/ld+json" } };
const JSONLD_HEADERS = { headers: { "Content-Type": "application/ld+json", Accept: "application/ld+json" } };
const MERGE_PATCH_HEADERS = { headers: { "Content-Type": "application/merge-patch+json", Accept: "application/ld+json" } };

export async function getTickets() {
  let allTickets = [];
  // on commence à la première page avec une grande taille
  let url = `${API_URL}?itemsPerPage=1000&pagination=false&page=1`;

  while (url) {
    const res = await api.get(url, ACCEPT_JSONLD);
    const data = res.data;

    // ajoute les tickets de cette page
    allTickets = allTickets.concat(fromApiListResponse(data));

    // passe à la page suivante si elle existe
    if (data.view && data.view.next) {
      url = data.view.next; // peut être une URL absolue ou relative, axios gère les deux
    } else {
      url = null;
    }
  }

  return allTickets;
}

export async function getTicket(id) {
  const res = await api.get(`${API_URL}/${id}`, ACCEPT_JSONLD);
  // Retourner les données brutes pour compatibilité
  return res.data;
}

export async function addTicket(data) {
  const res = await api.post(API_URL, toApiPayload(data), JSONLD_HEADERS);
  // Retourner les données brutes pour compatibilité
  return res.data;
}

export async function updateTicket(id, data) {
  const res = await api.patch(`${API_URL}/${id}`, toApiPayload(data), MERGE_PATCH_HEADERS);
  // Retourner les données brutes pour compatibilité
  return res.data;
}

export async function deleteTicket(id) {
  await api.delete(`${API_URL}/${id}`, ACCEPT_JSONLD);
} 